module.exports = __webpack_public_path__ + "static/media/confirm_booking_requests.33c3fb41.jpg";